<template>
	<div class="MultiSelect">
		<div
		class="inputfield inputfield--select inputfield--multiselect"
		:class="{'inputfield--small': small}">
			<selectize
			class="MultiSelect__select"
			:class="{'MultiSelect__select--small': small}"

			ref="select"
			:disabled="computedDisabled"
			:name="name"
			:id="id"
			:multiple="false"
			:autocomplete="true"

			@input="updateValue">
				<option
				class="MultiSelect__option MultiSelect__option--custom"

				v-for="(option, index) in computedOptions"

				v-if="value.indexOf(getValue(option, index)) < 0"
				:value="getValue(option, index)"
				>{{ getText(option, index) }}</option>
			</selectize>
		</div>
		<ul class="MultiSelect__ul">
			<li
			class="MultiSelect__li"
			:class="{'MultiSelect__li--small': small}"
			v-for="(item, index) in value" >
				<span class="MultiSelect__li-text">{{ getTextFromValue(item, index) }}</span>
				<button
				class="MultiSelect__li-btn     st-btn st-btn--small st-btn--icon"
				:class="{ 'st-btn--disabled': disabled }"
				@click.prevent="removeValue(index)">
					<i aria-hidden="true" class="fa fa-close"></i>
				</button>
			</li>
		</ul>
	</div>
</template>

<script>

import Selectize from 'vue2-selectize';

export default {
	name: 'MultiSelect',
	components: {
    	Selectize
  	},
  	computed: {
  		computedOptions(){
  			var out = [];
  			for (var i = 0; i < this.options.length; i++) {
  				if(this.value.indexOf(this.getValue(this.options[i], i)) < 0){
  					out.push(this.options[i]);
	  			}
			}
			return out;
  		},
  		computedDisabled(){
  			if(this.computedOptions.length <= 0) return true;
  			return this.disabled;
  		}
  	},
	data() {

		var value = [];
		this.defaultValue.forEach((item, index)=> {
			if(typeof item == 'number') item = item.toString();
			value.push(item);
		});

		return {
			value
		};
	},
	props: {
		defaultValue: {
			default: () => [],
		},
		defaultText: {
			default: 'Bitte Wählen',
		},
		disabled: {
			type: Boolean,
			default: false,
		},
		options: {
			default: () => [],
		},
		name: {
			type: String,
			default: '',
		},
		small: {
			type: Boolean,
			default: false,
		},
		id: {
			type: String,
			default: '',
		}
	},
	methods: {
		getTextFromValue(opt, index){
			for (var i = this.options.length - 1; i >= 0; i--) {
				if(this.options[i].value == opt){
					return this.getText(this.options[i], index);
				}
			}
			return false;
		},
		getText(opt, index){
			if(typeof opt === 'string') {
				return opt;
			} else if(opt.label){

				if(opt.translate) {
					return this.$t(opt.label).trim();
				}

				return opt.label;
			}

			if(typeof this.options[opt] !== 'undefined') {
				return this.getText(this.options[opt]);
			} else if(typeof this.options[index] !== 'undefined') {
				return this.getText(this.options[index]);
			}

			return false;
		},
		removeValue(index){
			if(this.disabled) return;
			this.value.splice(index, 1)
			this.$emit('input', this.value);
		},
		getValue(option, index){
			let val = false;
			if(Array.isArray(this.options)){
				if(typeof option == 'object' && option.value){
					val =  option.value;
				} else {
					val = option;
				}
			} else {
				val = index;
			}

			if(typeof val === 'number') val = val.toString();
			return val;
		},
		updateValue(value) {

			if(value && value.length > 0 && this.value.indexOf(value) < 0){
				if(typeof value === 'string') {
					this.value.push(value);
				}
				else if(!Array.isArray(value) && typeof value == 'object' && value.value) {
					this.value.push(value.value);
				}
				else {
					this.value.push(value);
				}

				this.$emit('input', this.value);
				this.$refs.select.value = '';
			}
		}
	}
}
</script>

<style lang="scss">
.MultiSelect {
	line-height: 1.5714285714;
	font-size: 18px;
	color: #3E4C57;
	&__select {
		margin-bottom: 0;
	}

	&__ul {
		font-size: .85em;
		list-style: none;
		margin: 0;
		padding: 0;
		&:before,
		&:after {
			content: "";
			display: block;
			clear: both;
		}
	}
	&__li {
		padding: .24em .24em .24em 1.5em;
		margin-bottom: .24em;
		margin-right: .24em;
		float: left;
		border-bottom: 1px solid #b8b8b8;
		background-color: #D1D5DD;

		&-text {
			padding-right: .24em;
		}
		&-btn {
			font-size: 12px;
			float: right;
		}

		&:last-child {
			margin-right: 0;
			margin-bottom: 0;
		}
	}
}
</style>



// WEBPACK FOOTER //
// src/components/MultiSelect.vue